// extracted by mini-css-extract-plugin
module.exports = {"LoginPage":"page_LoginPage__1avo5","appear":"page_appear__3bcWR"};